export default __webpack_public_path__ + "static/media/ca.619de8cc.svg";